import script from "./DashboardMixin.vue?vue&type=script&lang=js"
export * from "./DashboardMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__